export const ToggleButton = (className) => {
    const result = document.body.classList.contains(
        className
    );
    if (result) document.body.classList.remove(className);
    else document.body.classList.add(className);
}